export const lang = {
  lang: '한국어',
};
